( function( $, document, window ) {
	$( '.img-parallax' ).each( function() {
		var img = $( this );
		var imgParent = $( this ).parent();
		var parallaxImg = function() {
			var speed = 1;
			var imgY = imgParent.offset().top;
			var winY = $( window ).scrollTop();
			// var winH = $( window ).height();
			var winH = window.innerHeight > 0 ? window.innerHeight : screen.height;
			var parentH = imgParent.innerHeight();


			// The next pixel to show on screen
			var winBottom = winY + winH;

			// If block is shown on screen
			if ( winBottom > imgY && winY < imgY + parentH ) {
				// Number of pixels shown after block appear
				var imgBottom = ( winBottom - imgY ) * speed;
				// Max number of pixels until block disappear
				var imgTop = winH + parentH;

				// Porcentage between start showing until disappearing
				var imgPercent = ( ( imgBottom / imgTop ) * 100 ) + ( 50 - ( speed * 50 ) );

				img.css( {
					top: imgPercent + '%',
					transform: 'translate( -50%, -' + imgPercent + '% )'
				} );
			}
		};

		$( document ).on( {
			scroll: function() {
				parallaxImg();
			}, ready: function() {
				parallaxImg();
			}
		} );
	} );
} )( jQuery, document, window );
